import { render } from "./App.vue?vue&type=template&id=2269ceab"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2269ceab&lang=scss"

import exportComponent from "C:\\Users\\Cesar\\Documents\\Proyectos\\POSVitialife\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__